module.exports = __webpack_public_path__ + "media/images/vcard-2d48347d909136bfd9f24d861dd7a030.svg";